import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import agentService from "@/services/agent";

export const useAgentInstructionsStore = defineStore("agentInstructions", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchAllAgentsInstructionsGrid(companyId) {
    loading.value = true;
    try {
      const res = await agentService.getAllAgentsInstructionsGrid(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addAgentInstructions(payload) {
    loading.value = true;
    try {
      const res = await agentService.addAgentInstructions(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editAgentInstructions(payload) {
    loading.value = true;
    try {
      const res = await agentService.editAgentInstructions(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchAgentInstructionsById(payload) {
    loading.value = true;
    try {
      const res = await agentService.getAgentInstructionsById(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteAgentInstructions(payload) {
    loading.value = true;
    try {
      const res = await agentService.deleteAgentInstructions(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function previewRecommendation(payload) {
    loading.value = true;
    try {
      return await agentService.previewRecommendation(payload);
    } catch (err) {
      toast.error(err?.data?.message || "Recommendation preview was refused.");
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function getRecommendationStatus(payload) {
    return agentService.getRecommendationStatus(payload);
  }

  async function activateRecommendation(payload) {
    loading.value = true;
    try {
      const res = await agentService.activateRecommendation(payload);
      toast.success(res.message || "Recommendation publication accepted.");
      return res;
    } catch (err) {
      toast.error(err?.data?.message || "Recommendation activation was refused.");
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function retryRecommendation(payload) {
    loading.value = true;
    try {
      const res = await agentService.retryRecommendation(payload);
      toast.success(res.message || "Recommendation publication retry accepted.");
      return res;
    } catch (err) {
      toast.error(err?.data?.message || "Recommendation retry was refused.");
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchAllAgentsInstructionsGrid,
    addAgentInstructions,
    editAgentInstructions,
    fetchAgentInstructionsById,
    deleteAgentInstructions,
    previewRecommendation,
    getRecommendationStatus,
    activateRecommendation,
    retryRecommendation,
  };
});
